<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
	import apiUrls from "@api";
	export default{
		watch: {  
			'$route': {
			handler(to, from) {
				// console.log(to)
				let hrefs =  encodeURIComponent(document.location.href);
				console.log(hrefs)
				apiUrls.visitLog({url:hrefs})
			},
			immediate: true  // 首次进入页面即执行
			}  
		}
	}
</script>

<style lang="less">
*{
  padding: 0;
  margin: 0;
}
body{
  background-color: #fff !important;
}

</style>
